import { render } from "./NewPeriziaDetail.vue?vue&type=template&id=7bd8f304&scoped=true"
import script from "./NewPeriziaDetail.vue?vue&type=script&lang=js"
export * from "./NewPeriziaDetail.vue?vue&type=script&lang=js"

import "./NewPeriziaDetail.vue?vue&type=style&index=0&id=7bd8f304&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd8f304"]])

export default __exports__